module.exports = __webpack_public_path__ + "static/media/cube.f9f82fb2.svg";